import React from 'react';
import {connect} from 'react-redux';
import ShoppingItem from './ShoppingItem.jsx';
import {Products, Orders} from 'api';
import {LoadingPage} from 'components/loading-page';
import {RightStickerContainer} from 'components/partials/right-sticker';
import {ShowIf} from 'components/utils';
import moment from 'moment';
import {toastr} from 'react-redux-toastr';
import {NoContent} from 'components/no-content';
import uniq from 'lodash/uniq';
import OrderForm from './OrderForm';
import {getPrice} from 'lib/convert';

class ShoppingCart extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      isLoading: false,
      showForm: false,
      totalPricePayment: 0,
      businessIds: []
    };
    this.onChange = this.onChange.bind(this);
    this.showFormOrder = this.showFormOrder.bind(this);
  }

  componentDidMount() {
    this.getShoppingCart(this.props.shoppingCart);
  }

  componentWillReceiveProps(nextProps) {
    this.getShoppingCart(nextProps.shoppingCart);
  }

  getShoppingCart(items) {
    if (items.length > 0) {
      const params = {
        filter: {
          where: {id: {inq: items}}
        }
      };
      this.setState({isLoading: true});
      Products.actions.list.request(params).then((response) => {
        let totalPrice = 0;
        let products = [];
        let business = [];
        response.data.map((item) => {
          products.push({
            count: 1,
            ...item
          });
          business.push(item.businessId);
          let finalPrice = getPrice(item.promotionalPrice || item.price, null);
          totalPrice += finalPrice;
        });
        this.setState({isLoading: false, data: products, totalPricePayment: totalPrice, businessIds: uniq(business)});
      }).catch(() => {
        this.setState({isLoading: false});
      });
    }
  }

  onChange(item) {
    let products = this.state.data;
    let totalPrice = 0;
    products.map((value, key) => {
      if (value.id === item.id) {
        products[key].count = item.count;
        let finalPrice = getPrice(item.promotionalPrice || item.price, null);
        totalPrice += finalPrice * item.count;
      } else {
        let finalPrice = getPrice(value.promotionalPrice || value.price, null);
        totalPrice += finalPrice * value.count;
      }
    });
    this.setState({data: products, totalPricePayment: totalPrice});
  }

  showFormOrder() {
    this.setState({showForm: !this.state.showForm});
  }

  render() {
    const {isLoading} = this.state;
    return (
      <div className="shopping-cart-container">
        <LoadingPage isShow={isLoading} />
        <ShowIf condition={this.state.data.length > 0}>
          <div className='shopping-cart-left-content'>
            <ShowIf condition={this.state.showForm}>
              <OrderForm
                showForm={this.showFormOrder}
                products={this.state.data}
                amount={this.state.totalPricePayment}
                businessIds={this.state.businessIds}
              />
            </ShowIf>
            <ShowIf condition={!this.state.showForm}>
              <div className="table-list-item-shopping">
                <div className='table-list-item-header'>
                  <p className='table-list-item-header-content'>Thông tin sản phẩm</p>
                  <p className='table-list-item-header-content'>Đơn giá</p>
                  <p className='table-list-item-header-content'>Số lượng</p>
                </div>
                <div className='table-list-item-body'>
                  {
                    this.state.data.map((item, idx) => {
                      return (
                        <ShoppingItem disabled={isLoading} onChange={this.onChange} key={idx} {...item}/>
                      );
                    })
                  }
                </div>
              </div>
            </ShowIf>
          </div>
        </ShowIf>
        <ShowIf condition={!isLoading && this.state.data.length == 0}>
          <NoContent content='Không có sản phẩm nào' height={680}/>
        </ShowIf>
        <ShowIf condition={this.state.data.length > 0 && !this.state.showForm}>
          <div className='shopping-cart-right-content'>
            <RightStickerContainer>
              <div className='shopping-order-container'>
                <div className='content-justify mb20'>
                  <p className='shopping-order-title'>Tạm tính</p>
                  <p className='shopping-order-content-black'>{getPrice(this.state.totalPricePayment)}</p>
                </div>
                <div className='content-justify mb5'>
                  <p className='shopping-order-title'>Thành tiền</p>
                  <p className='shopping-order-content-red'>{getPrice(this.state.totalPricePayment)}</p>
                </div>
                <p className='shopping-order-content-desc mb20'>(Đã bao gồm VAT)</p>
                <button onClick={this.showFormOrder} className='btn-order-product'>TIẾN HÀNH ĐẶT HÀNG</button>
              </div>
            </RightStickerContainer>
          </div>
        </ShowIf>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    shoppingCart: state.shoppingCart.items,
    user: state.auth.user
  };
};

export default connect(mapStateToProps)(ShoppingCart);



// WEBPACK FOOTER //
// ./components/users/sub-view/shopping-cart/ShoppingCart.jsx